﻿import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Text } from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useCommonStyles } from '../../../common/hooks';

interface SubmitJudgingModalProps {
  isModalOpen: boolean;
  onDismissModal(): void;
  onSubmitAndNextButtonClicked(): void;
  onSubmitAndExitButtonClicked(): void;
  isHideContinueButton: boolean;
}

const SubmitJudgingModalImpl: React.FC<SubmitJudgingModalProps> = (props) => {
  const {
    isModalOpen,
    onDismissModal,
    onSubmitAndNextButtonClicked,
    onSubmitAndExitButtonClicked,
    isHideContinueButton,
  } = props;

  const commonStyles = useCommonStyles();

  return (
    <Dialog
      open={isModalOpen}
      onOpenChange={(_, data) => {
        if (!data.open) onDismissModal();
      }}
    >
      <DialogSurface className={commonStyles.modalSurface}>
        <DialogBody className={commonStyles.modalBody}>
          <DialogTitle
            action={<Button
              appearance='transparent'
              title='Close'
              icon={<DismissRegular />}
              onClick={onDismissModal}
            />}
          >
            Submit nomination
          </DialogTitle>
          <DialogContent>
            <Text as='p'>
              Once you submit this nomination you’ll be able to return to it throughout the Judging Window. To judge the next nomination click <strong>Submit &amp; next</strong>. Click <strong>Submit &amp; exit</strong> to be brought to the program dashboard.
            </Text>
          </DialogContent>
          <DialogActions fluid>
            <Button
              appearance='secondary'
              onClick={() => onDismissModal()}
            >
              Back
            </Button>
            <Button
              appearance='primary'
              onClick={() => onSubmitAndExitButtonClicked()}
            >
              Submit & exit
            </Button>
            {
              !isHideContinueButton &&
              <Button
                appearance='primary'
                onClick={() => onSubmitAndNextButtonClicked()}
              >
                Submit & next
              </Button>
            }
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export const SubmitJudgingModal = observer(SubmitJudgingModalImpl);
